import { Shield, Droplets, Home, PiggyBank } from 'lucide-react';

const benefits = [
  {
    icon: Clock,
    title: 'Förlänger fönstrens livslängd',
    description: 'Med rätt underhåll och professionell målning kan dina fönster hålla i flera decennier längre än om de lämnas utan omsorg.',
    large: true,
  },
  {
    icon: Droplets,
    title: 'Skyddar mot fukt och röta',
    description: 'Fukt är fönsters värsta fiende. Vi säkerställer att varje fönster får ett skyddande lager som förhindrar vatteninträngning.',
  },
  {
    icon: Home,
    title: 'Bättre helhetsintryck',
    description: 'Nymålade fönster lyfter hela fasaden och ger ditt hem ett fräscht, välskött utseende.',
  },
  {
    icon: PiggyBank,
    title: 'Billigare än fönsterbyte',
    description: 'Att renovera och måla fönster kostar en bråkdel av vad det kostar att byta ut dem helt. Du sparar pengar och bevarar husets karaktär.',
    large: true,
  },
];

// Import Clock separately since we use it in benefits
import { Clock } from 'lucide-react';

export const BenefitsSection = () => {
  return (
    <section id="benefits" className="section-padding bg-white" data-testid="benefits-section">
      <div className="container-custom">
        {/* Section header */}
        <div className="max-w-3xl mb-16 animate-fade-in-up">
          <span className="text-[#C0392B] font-medium text-sm uppercase tracking-wider mb-4 block">
            Fördelar
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-[#1F2937] mb-6">
            Varför professionell fönstermålning?
          </h2>
          <p className="text-base md:text-lg text-[#64748B]">
            Fönster utsätts för sol, regn, frost och värme varje dag. Med rätt underhåll 
            skyddar du din investering och bevarar husets värde.
          </p>
        </div>

        {/* Bento grid */}
        <div className="bento-grid">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <div
                key={index}
                className={`bento-card animate-fade-in-up ${benefit.large ? 'bento-large' : ''}`}
                style={{ animationDelay: `${index * 100}ms` }}
                data-testid={`benefit-card-${index}`}
              >
                <div className="w-14 h-14 bg-[#F1F5F9] flex items-center justify-center mb-6">
                  <IconComponent className="w-7 h-7 text-[#2C3E50]" />
                </div>
                <h3 className="text-xl font-heading font-semibold text-[#1F2937] mb-3">
                  {benefit.title}
                </h3>
                <p className="text-[#64748B] leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Image section */}
        <div className="mt-16 grid md:grid-cols-2 gap-8 items-center">
          <div className="img-hover-zoom">
            <img
              src="https://images.unsplash.com/photo-1541279573513-aaeb6cf378e7?w=600&h=400&fit=crop&q=80"
              alt="Detaljbild på fönstermålning med precision"
              className="w-full h-auto shadow-lg"
              loading="lazy"
            />
          </div>
          <div className="animate-fade-in-up">
            <h3 className="text-2xl font-heading font-semibold text-[#1F2937] mb-4">
              Precision i varje penselstrykning
            </h3>
            <p className="text-[#64748B] mb-6">
              Vi tar oss tid att göra rätt från början. Det innebär noggrann förberedelse, 
              rätt val av färg och en finish som håller i åratal. Resultatet? Fönster som 
              ser ut som nya och skyddas mot väder och vind.
            </p>
            <ul className="space-y-2">
              {['Skrapning av gammal färg', 'Slipning och grundning', 'Flera lager högkvalitativ färg'].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-[#1F2937]">
                  <div className="w-2 h-2 bg-[#C0392B]" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
